/* eslint-disable no-unused-vars */
import { TourBagDetail } from '@/api/models';

export class TourBagDetailAddNew implements TourBagDetail {
  constructor(
    public tourBagMstrId = -1,
    public tourBagDetailId = -1,
    public appUserName = '',
    public playerId = 0,
    public playerName = '',
    public headTypeId = 0,
    public headTypeDescription = '',
    public headModelId = 0,
    public headModelName = '',
    public tourId = 0,
    public tourName = '',
    public itemNo = 0,
    public editSource = 'web',
    public hand = '',
    public shaftName = '',
    public shaftPinstamp = '',
    public shaftCosmetic = '',
    public shaftTippingDigit = '',
    public shaftTippingFractionId = 0,
    public shaftTippingFractionId1 = 0,
    public shaftTippingFraction = '',
    public isShaftLengthFinished = false,
    public shaftLengthDigitId = 0,
    public shaftLengthDigitId1 = 0,
    public shaftLengthDigit = '',
    public shaftLengthFraction = '',
    public shaftLengthFractionId = 0,
    public shaftLengthFractionId1 = 0,
    public settingId = 0,
    public settingName = '',
    public cgFlatWeightId = 0,
    public cgFlatWeightName = '',
    public weightNameLookupId = 0,
    public weightNameLookupName = '',
    public headWeightLocationLookupId = 0,
    public headWeightLocationLookupName = '',
    public headWeightNumberLookupId = 0,
    public headWeightNumberLookupName = '',
    public loftId = 0,
    public loftName = '',
    public loftDigitId = 0,
    public loftDigit = '',
    public loftFractionId = 0,
    public loftFraction = '',
    public loftDigitId1 = 0,
    public loftFractionId1 = 0,
    public lieDigitId = 0,
    public lieDigit = '',
    public lieFractionId = 0,
    public lieFraction = '',
    public lieDigitId1 = 0,
    public lieFractionId1 = 0,
    public measuredLoft = 0,
    public serialMstrId = 0,
    public laserNo = '',
    public ct = 0,
    public ctLocation = '',
    public swingWtPrefixId = 0,
    public swingWtPrefixName = '',
    public swingWtSuffixId = 0,
    public swingWtSuffixName = '',
    public gripTypeId = 0,
    public gripType = '',
    public gripTape = '',
    public gripSizeId = 0,
    public gripSize = '',
    public tape = '',
    public rndRib = '',
    public logo = '',
    public sleeve = '',
    public sleeveId = 0,
    public sleeveName = '',
    public shaftFlexId = 0,
    public shaftFlexName = '',
    public shaftBendName = '',
    public yearId = 0,
    public yearName = '',
    public lie = 0,
    public sightLine = '',
    public neck = '',
    public weights = '',
    public metalId = 0,
    public metalName = '',
    public shaftBendId = 0,
    public putterHeadType = '',
    public putterLevelId = 0,
    public putterLevelName = '',
    public putterTypeId = 0,
    public putterTypeName = '',
    public putterSightLineId = 0,
    public putterSightlineName = '',
    public putterFaceId = 0,
    public putterFaceName = '',
    public putterNeckId = 0,
    public putterNeckName = '',
    public putterGripId = 0,
    public putterGripName = '',
    public putterShaftId = 0,
    public putterShaftName = '',
    public putterWeightId = 0,
    public putterWeightName = '',
    public paintingNotes = '',
    public familyId = 0,
    public familyName = '',
    public familyNote = '',
    public headFinishId = 0,
    public headFinishName = '',
    public headFinishNote = '',
    public stamping = '',
    public grindDetails = '',
    public ratGlue1 = '',
    public ratGlue2 = '',
    public ratGlue3 = '',
    public ratGlue4 = '',
    public ratGlue5 = '',
    public ratGlue6 = '',
    public ratGlue7 = '',
    public notes = '',
    public orderDetailId = 0,
    public tourBagMstrRowGuid = '',
    public isActive = false,
    public modifyDate = new Date(),
    public modifyUserGuid = '',
    public modifyUserName = '',
    public createDate = new Date(),
    public createUserGuid = '',
    public rowGuid = '',
    public tstamp = '',
    public overallWeight = 0.0,
    // Fields added for Final Head Weight
    public headWeight = 0,
    public drill = 0,
    public tipPlug = 0,
    public leadTape = 0,
    public glueWeight = 0,
    public headModelAlternateName = '',
  ) {}
}
